export default __webpack_public_path__ + "static/certificate-oss-0267834f6a2150a7f42e09d63b60c72d.svg";